<template>
  <div class="toast" v-if="$store.state.toast.open" @click="close">
    <img src="/images/icons/toast.svg" alt="" />
    <span>
      {{ $store.state.toast.message }}
    </span>
  </div>
</template>

<script>
export default {
  name: 'ToastPlugin',

  methods: {
    close() {
      this.$store.commit('setToast', {
        open: false,
        message: ''
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.toast {
  position: fixed;
  right: 12px;
  top: 12px;

  display: flex;
  align-items: center;
  width: 300px;
  height: 80px;
  padding: 27px 22px;
  z-index: 100;

  font-size: 12.5px;
  font-weight: 600;
  letter-spacing: 0.6px;
  line-height: 18px;
  text-transform: uppercase;

  background-color: #66bf44;
  box-shadow: 1px 1px 2px 0 rgba(0, 0, 0, 0.3);
  border-radius: 3px;
  color: white;

  img {
    margin-right: 14px;
  }

  span {
    margin: 1px 0 0;
  }
}
</style>



// WEBPACK FOOTER //
// resources/assets/frontend/js/components/Toast.vue